module.exports = __webpack_public_path__ + "a1636ded8465b995f65eaf7ae76380e9.svg";